import { z } from "zod";

const Forgotschema = z.object({
  email: z.string().nonempty("This is required").email("Must be a valid email"),
});
export default Forgotschema;
